/**
 * Options for mobile auth routes (send OTP / verify OTP).
 *
 * - REACT_APP_MOBILE_CREDENTIALS=true — send cookies on cross-origin calls (needs CORS credentials).
 * - REACT_APP_MOBILE_API_KEY — sent as x-api-key when set.
 * - REACT_APP_MOBILE_BEARER_TOKEN — static Bearer for dev/gateway when set.
 * - REACT_APP_SKIP_SEND_LOGIN_OTP=true — skip send-OTP before OTP entry (UI-only flow).
 */
export function getMobileAuthRequestConfig(extra = {}) {
  const withCredentials =
    typeof process !== "undefined" &&
    process.env.REACT_APP_MOBILE_CREDENTIALS === "true";

  const headers = { ...(extra.headers || {}) };

  const staticBearer =
    typeof process !== "undefined" && process.env.REACT_APP_MOBILE_BEARER_TOKEN;
  if (staticBearer) {
    headers.Authorization = `Bearer ${staticBearer}`;
  }

  const apiKey = typeof process !== "undefined" && process.env.REACT_APP_MOBILE_API_KEY;
  if (apiKey) {
    headers["x-api-key"] = apiKey;
  }

  return {
    ...extra,
    withCredentials,
    headers: { ...extra.headers, ...headers },
  };
}

export function shouldSkipSendLoginOtp() {
  return (
    typeof process !== "undefined" &&
    process.env.REACT_APP_SKIP_SEND_LOGIN_OTP === "true"
  );
}
